/**
 * 密码长度规则。自己改密码（`auth/change-password`）和管理员直接设密码（`users/:id/set-password`，CR-077）
 * 用同一份，前端表单当场查的也是它 —— 以前 6 这个数在后端 DTO 和改密页各写了一遍。
 *
 * 工地场景不适合复杂密码规则，工人记不住也输不对；真正的防线是账号由管理员集中管理。
 */
export const PASSWORD_MIN_LENGTH = 6;
export const PASSWORD_MAX_LENGTH = 200;
//# sourceMappingURL=password-rules.js.map